import { useContext } from 'react'
import { CalendarArticleContext } from '../context/CalendarArticleContext'

export const useCalendarArticle = () => {
  const context = useContext(CalendarArticleContext)
  if (context === undefined) {
    throw new Error(
      'useCalendarArticleContext must be used within a CalendarArticleProvider'
    )
  }
  return context
}
